exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".inp-table[data-v-2dd1eef6]{height:100%}.inp-table .cln-numero[data-v-2dd1eef6]{width:100px;min-width:100px}.inp-table .cln-periode[data-v-2dd1eef6]{-ms-flex-positive:1;flex-grow:1}.inp-table .cln-etat[data-v-2dd1eef6]{width:125px;min-width:125px}.inp-table .cln-declaration[data-v-2dd1eef6]{width:200px;min-width:200px}.inp-table .cln-action[data-v-2dd1eef6]{width:250px;min-width:250px}.inp-table .tbody .line[data-v-2dd1eef6]{background-image:url(" + require("../../../assets/bg_tableau.png") + ")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-2dd1eef6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/dsn/tableOeth/tableOeth.scss
// module id = mZqx
// module chunks = 2